import { render, staticRenderFns } from "./RedPacketSettings.vue?vue&type=template&id=73c1baaa&scoped=true"
import script from "./RedPacketSettings.vue?vue&type=script&lang=js"
export * from "./RedPacketSettings.vue?vue&type=script&lang=js"
import style0 from "./RedPacketSettings.vue?vue&type=style&index=0&id=73c1baaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c1baaa",
  null
  
)

export default component.exports